import GetIntelligentialNews from '@/graphql/News/GetIntelligentialNews.gql'
import { createProvider } from '../../vue-apollo'

const apollo = createProvider()

export default {
  async getIntelligentialNews (_, { cursor, limit }) {
    const result = await apollo.defaultClient.query({
      query: GetIntelligentialNews,
      variables: { cursor, limit },
      fetchPolicy: 'no-cache'
    })
    const { news, pagination } = result.data.GetIntelligentialNews
    return {
      items: news,
      nextCursor: pagination.nextCursor,
      hasNext: pagination.hasNextPage
    }
  }
}
